import { useRouter } from 'next/router';
import { isEqual } from 'lodash';
import { useRef } from 'react';

import { MediaQuery, useMediaQuery } from '../../../hooks/useMediaQuery';
import { redirectLink } from '../../../utils/tabs';
import { TabItem } from '../../../types/tabs';
import { PRIMARY_GRAY, WHITE } from '../../../constants/colors';
import {
  MIN_TABS_ITEMS_FOR_COLS,
  TABS_DESKTOP_SCROLL_POSITION,
  TABS_TABLET_SCROLL_POSITION,
  TABS_MOBILE_SCROLL_POSITION
} from '../../../constants/tabs';

/* eslint-disable-next-line */
type TabsProps = {
  tabItems: TabItem[];
};

export function Tabs(props: TabsProps) {
  const { tabItems } = props;
  const router = useRouter();
  const tabsRef = useRef<any>(null);

  const isMobile = useMediaQuery(MediaQuery.SM);
  const isTablet = useMediaQuery(MediaQuery.LG);

  const tabsScrollPosition = isMobile
    ? TABS_MOBILE_SCROLL_POSITION
    : isTablet
    ? TABS_TABLET_SCROLL_POSITION
    : TABS_DESKTOP_SCROLL_POSITION;

  const renderTabItems = tabItems.map((tabItem) => {
    const textColor = isEqual(router.asPath, tabItem.route)
      ? PRIMARY_GRAY
      : WHITE;

    function disableRedirect(e: any) {
      e.preventDefault();

      return false;
    }

    return (
      <div className="leading-7" key={tabItem.tabLabel} ref={tabsRef}>
        <button
          className="font-MuseoSans100 text-caption cursor-pointer xs:underline lg:no-underline"
          style={{ color: textColor }}
          onClick={() =>
            redirectLink(
              tabItem.tabLabel,
              tabItem.route,
              tabsRef?.current?.offsetTop - tabsScrollPosition
            )
          }
        >
          <a href={tabItem.route} onClick={disableRedirect}>
            {tabItem.tabLabel}
          </a>
        </button>
      </div>
    );
  });

  const isMoreThanMinTabs = tabItems.length > MIN_TABS_ITEMS_FOR_COLS;

  return (
    <div className="w-full bg-black">
      <div
        className={`w-full max-w-defaultMax flex flex-col justify-center lg:flex-row ${
          isMoreThanMinTabs ? 'justify-between' : 'lg:space-x-10'
        } gap-x-1 text-center py-4 px-2 m-auto`}
      >
        {renderTabItems}
      </div>
    </div>
  );
}

export default Tabs;
